import BaseAPI from "@/apis/base/baseApi";
import httpClient from "@/apis/base/httpclient";
import { MSEnum } from '@/commons/enumeration'
class SurveyCustomerAPI extends BaseAPI {
    constructor() {
        super();
    }
    apiName = 'TaskGo';
    controllerName = 'SurveyCustomers';
    /**
     * Lấy danh sách các khảo sát đang hoạt động
     * NTDIEM 08/01/2024
     * @param {*} payload 
     * @returns 
     */
    getListServeyForUser(payload) {
        let request = {
            url: this.getAPIUrl() + "/GetListServeyForUser",
            data: payload
        };
        return httpClient.postAsync(request);
    }

    /**
     * Lưu khảo sát
     * NTDIEM 08/01/2024
     * @param {*} payload 
     * @returns 
     */
    SaveServeyResult(payload) {
        let request = {
            url: this.getAPIUrl() + "/SaveServeyResult",
            data: payload
        };
        return httpClient.postAsync(request);
    }

    /**
     * Update đếm số lần người dùng đóng khảo sát
     * NTDIEM 08/01/2024
     * @param {*} payload 
     * @returns 
     */
    UpdateCancelCount(payload) {
        let request = {
            url: this.getAPIUrl() + "/UpdateCancelCount",
            data: payload
        };
        return httpClient.postAsync(request);
    }

    /**
     * Lấy khảo sát mới nhất của người dùng
     * NTDIEM 08/01/2024
     * @param {*} payload 
     * @returns 
     */
    getLastestServeyForUser(payload) {
        let request = {
            url: this.getAPIUrl() + "/GetLastestServeyForUser",
            data: payload
        };
        return httpClient.postAsync(request);
    }
}

export default new SurveyCustomerAPI();
